import {
  ADD_TRAINING_FAIL,
  ADD_TRAINING_SUCCESS,
  DELETE_TRAINING_LINK_FAIL,
  DELETE_TRAINING_LINK_SUCCESS,
  GET_TRAININGS_LIST_FAIL,
  GET_TRAININGS_LIST_SUCCESS,
  ASSIGN_TRAININGS_FAIL,
  ASSIGN_TRAININGS_SUCCESS,
  UPDATE_TRAINING_LINK_FAIL,
  UPDATE_TRAINING_LINK_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  list: [],
  res: [],
  error: [],
  dltRes: [],
  assignRes: [],
};

const Training = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ASSIGN_TRAININGS_SUCCESS:
      return {
        ...state,
        assignRes: action.payload,
      };
    case ASSIGN_TRAININGS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_TRAININGS_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case GET_TRAININGS_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_TRAINING_LINK_SUCCESS:
      return {
        ...state,
        dltRes: action.payload,
      };
    case DELETE_TRAINING_LINK_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_TRAINING_LINK_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_TRAINING_LINK_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_TRAINING_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_TRAINING_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default Training;
